export default __webpack_public_path__ + "d88f4afce7e5a2e3c3eea578318e60df.png";